module.exports = __webpack_public_path__ + "static/media/dianHuaBang.6b0009a5.jpeg";